import { combineReducers } from 'redux'
import * as ActionTypes from '../../actions/actionTypes'

const entitiesCategories = (state = {}, action) => {
    switch (action.type) {
        case ActionTypes.EXPEDIA_EASYMS_CATEGORIES_FETCH_SUCCESS:
            const { categories } = action.payload.entities
            return { ...state, categories }
        case ActionTypes.EXPEDIA_CURRENT_ORGANIZATION_CHANGE:
            return {}
        default:
            return state
    }
}

/**@reducer**/
const resultCategories = (state = [], action) => {
    switch (action.type) {
        case ActionTypes.EXPEDIA_EASYMS_CATEGORIES_FETCH_SUCCESS:
            return [...action.payload.result]
        case ActionTypes.EXPEDIA_CURRENT_ORGANIZATION_CHANGE:
            return []
        default:
            return state
    }
}

const entitiesRates = (state = {}, action) => {
    switch (action.type) {
        case ActionTypes.EXPEDIA_EASYMS_RATES_FETCH_SUCCESS:
            const { rates } = action.payload.entities
            return { ...state, rates }
        case ActionTypes.EXPEDIA_CURRENT_ORGANIZATION_CHANGE:
            return {}
        default:
            return state
    }
}

/**@reducer**/
const resultRates = (state = [], action) => {
    switch (action.type) {
        case ActionTypes.EXPEDIA_EASYMS_RATES_FETCH_SUCCESS:
            return [...action.payload.result]
        case ActionTypes.EXPEDIA_CURRENT_ORGANIZATION_CHANGE:
            return []
        default:
            return state
    }
}

const categories = combineReducers({
    entities: entitiesCategories,
    result: resultCategories
})

const rates = combineReducers({
    entities: entitiesRates,
    result: resultRates
})

export default combineReducers({ categories, rates })



// WEBPACK FOOTER //
// ./src/reducers/expediaReducers/expediaEasyms.js